import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { imagineItems } from '../../data/salesContent';
export function ImagineSection() {
  return <section className="border-y border-gold/15 bg-ink-warm px-5 py-20 md:py-28" data-id="element-95" data-mp="1us6lpjjia1bm">
      <div className="mx-auto max-w-5xl" data-id="element-96" data-mp="1pv7rl0zududf">
        <SectionHeading title="¿Y si la próxima vez no empezaras desde cero?" subtitle="Imaginá abrir un único sistema y encontrar:" data-id="element-97" data-mp="1pw983kzmn92j" />
        <ul className="mx-auto mt-12 grid max-w-4xl gap-x-10 gap-y-4 sm:grid-cols-2" data-id="element-98" data-mp="x6sfam83hq5s">
          {imagineItems.map(item => <li key={item} className="flex items-center gap-4 rounded-xl bg-black/40 px-5 py-4 text-lg font-medium text-cream md:text-xl" data-id="element-99" data-mp="1b2ntierjud2u">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold text-black" data-id="element-100" data-mp="2mje5keinlz4d">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="2ihsjq3o56ai1" />
              </span>
              {item}
            </li>)}
        </ul>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase text-cream md:text-4xl" data-id="element-102" data-mp="3w44xgmvefvx8">
          Eso es <span className="text-gold" data-id="element-103" data-mp="40cf5mohenmw">Primeros Auxilios para Instructores™</span>
        </p>
        <div className="mt-10" data-id="element-104" data-mp="9076frc65f8h">
          <CtaButton data-id="element-105" data-mp="8z5iwndyv09v">Quiero dejar de preparar todo desde cero</CtaButton>
        </div>
      </div>
    </section>;
}